import React from 'react'
import { Form } from 'antd';
import { useFormik } from 'formik';
import { useMutation } from 'react-query';
import { api } from '../../../../../api/api';
import { useFormStatus } from '../../../../../utils/hooks/useFormStatus';
import FormStatus from '../../../../../components/form/FormStatus/FormStatus';
import { TypeOfTrainingFormFields } from '../../../../../types/formFieldTypes';
import { getAntField } from '../../../../../utils/form';
import { errorNotification, invalidateQueries } from '../../../../../utils/rest';
import TypeOfTrainingFormInputs from '../TypeOfTrainingFormInputs/TypeOfTrainingFormInputs';
import { clearTypeOfTrainingErrors, initialTypeOfTrainingFields, typeOfTrainingValidate } from '../../formData/TypeOfTrainingPageFormData';
import { queryKeysTypeOfTraining } from '../../../../../static/data/queryKeys';

type TypeOfTrainingAddFormProps = {
    setOpenedForm: React.Dispatch<React.SetStateAction<boolean>>
}

const TypeOfTrainingAddForm: React.FC<React.PropsWithChildren<TypeOfTrainingAddFormProps>> = React.memo(() => {

    const formStatus = useFormStatus()

    const {
        errors, values, touched,
        handleChange,
        submitForm, setValues, setErrors,
    } = useFormik<TypeOfTrainingFormFields>({
        initialValues: initialTypeOfTrainingFields,
        validateOnChange: false,
        onSubmit: (values) => {
            mutate(values)
        },
        validate: typeOfTrainingValidate
    })

    const antField = getAntField<TypeOfTrainingFormFields>(values, errors, touched)

    const {
        mutate
    } = useMutation(
        api.typeOfTrainings.create,
        {
            mutationKey: 'type-training-add',
            onSuccess() {
                invalidateQueries(queryKeysTypeOfTraining[0])
                formStatus.setMessage('Объект успешно добавлен')
                formStatus.setStatus('success')
                setTimeout(clearEditItem, 1000)
            },
            onError: (err: Error) => errorNotification(err, 'Ошибка создания', formStatus),
            onMutate() {
                formStatus.setMessage('Отправка данных')
                formStatus.setStatus('fetching')
            }
        }
    )

    const clearForm = () => {
        setValues(initialTypeOfTrainingFields)
        setErrors(clearTypeOfTrainingErrors)
    }

    const clearEditItem = () => {
        clearForm()
        setTimeout(formStatus.reset, 300)
    }

    return (
        <Form fields={[ antField('name') ]}>
            <TypeOfTrainingFormInputs
                handleChange={handleChange}
                clearForm={clearForm}
                submitForm={submitForm}
            />
            <FormStatus formStatus={formStatus} />
        </Form>
    )
})

export default TypeOfTrainingAddForm